import type Phaser from 'phaser';
import { prefersReducedMotion } from '../fx/motion';
import { WALLET_BAR_H, menuBarFrame, sheetMotion } from './menuPlan';
import { readSafeBottom } from './safeInset';
import { stage } from './stage';

/** Rise a popup over the page. The dim rides along. Reduced motion settles in place. */
export function slideSheet(scene: Phaser.Scene, root: Phaser.GameObjects.Container): void {
  const motion = sheetMotion(stage.h);
  if (prefersReducedMotion()) {
    root.y = motion.toY;
    return;
  }
  root.y = motion.fromY;
  scene.tweens.add({
    targets: root,
    y: motion.toY,
    duration: motion.duration,
    ease: 'Cubic.easeOut',
  });
}

/**
 * Keep a sheet between the wallet and the tab bar while the shell is up.
 * `top` and `left` are the card's authored top-left, before this fit.
 * On the title, where there is no shell, the card keeps the full stage.
 */
export function fitSheetCard(
  scene: Phaser.Scene,
  card: Phaser.GameObjects.Container,
  top: number,
  left: number,
  width: number,
  height: number,
): void {
  const shellUp = scene.scene.isActive('shell');
  const roomTop = shellUp ? WALLET_BAR_H + 10 : 8;
  const roomBottom = shellUp ? menuBarFrame(stage.h, scene.scale.height, readSafeBottom(0)).woodTop - 10 : stage.h - 8;
  const roomH = Math.max(120, roomBottom - roomTop);
  const roomW = Math.max(120, stage.w - 24);
  const scale = Math.min(1, roomH / Math.max(1, height), roomW / Math.max(1, width));
  card.setScale(scale);
  const visualTop = roomTop + (roomH - height * scale) / 2;
  const visualLeft = (stage.w - width * scale) / 2;
  card.x = visualLeft - left * scale;
  card.y = visualTop - top * scale;
}
